export default "__VITE_ASSET__d99d5d13__"